import {nanoid} from "nanoid";

const getTypesCount = (files) => {
    const result = files.reduce((acum, {type, url}) => {
        const typeName = (type === "jpg" || type === "jpeg") ? "jpg" : type;
        const item = acum.find(({type}) => type === typeName);
        if(item) {
            item.value += 1;
            item.urls.push(url);
            return acum;
        }
        return [...acum, {
            id: nanoid(),
            type: typeName,
            value: 1,
            urls: [url]
        }]
    }, []);

    return result;
};

export default getTypesCount;
